import React from 'react';
import '../css/OurPeople.css';
import { Linkedin, Mail } from 'lucide-react';

interface Person {
  name: string;
  title: string;
  company?: string;
  linkedinUrl: string;
  email: string;
  bio: string;
}

const OurPeople: React.FC = () => {
  const people: Person[] = [
    {
      name: 'Kim Coetzer',
      title: 'CTO, CO-FOUNDER',
      linkedinUrl: 'https://www.linkedin.com/in/kimcoetzer',
      email: 'kim.coetzer@crikeytech.com',
      bio: 'Leads teams delivering innovative enterprise data and AI to medium to large insurance companies. From concept to execution, Kim unites vision, strategy and teams for transformative ventures.'
    },
    {
      name: 'Alan Sheen',
      title: 'CIO, CO-FOUNDER',
      linkedinUrl: 'https://www.linkedin.com/in/alan-sheen-48844a364',
      email: 'alan.sheen@crikeytech.com',
      bio: 'Designed / Built / Tested and Run Machine Learning and Large Language Models at Credit Suisse and Dalton Street Capital. Co-Founder of Dalton Street Capital raising $100M. Alan brings 25 years of expertise in AI, capital management, corporate directorship.'
    },
    {
      name: 'Fred Venter',
      title: 'CEO, CO-FOUNDER',
      linkedinUrl: 'https://www.linkedin.com/in/frederickjventer',
      email: 'fred.venter@crikeytech.com',
      bio: 'Directs strategy - setting vision, direction and delivery ethos. From vision to execution, Fred drives governance and strategy for high-impact transformations.'
    },
    {
      name: 'Ethan Ward',
      title: 'HEAD OF AI',
      linkedinUrl: 'https://www.linkedin.com/in/ethanwardconsulting',
      email: 'ethan.ward@crikeytech.com',
      bio: 'Applies deep AI and software development knowledge to implement effetive solutions for complext use cases. Ethan extrcts value from implementing smart capabilities.'
    },
    {
      name: 'Albert Venter',
      title: 'CCO, CO-FOUNDER',
      linkedinUrl: 'https://www.linkedin.com/in/aventer1',
      email: 'albert.venter@crikeytech.com',
      bio: 'Ensures delivery of maximum value to customers through our data and AI solutions for the financial and insurance sectors, locally and internationally. Albert orchestres AI and data driven change from concept to bottom line.'
    },
    {
      name: 'Matt McBride',
      title: 'HEAD OF DELIVERY',
      linkedinUrl: 'https://www.linkedin.com/in/matthew-mcbride-749598296',
      email: 'matt.mcbride@crikeytech.com',
      bio: 'Facilitates outcomes by managing delivery processes and teams involved. Matt build relationships and trust while getting the job done.'
    },
    {
      name: 'Prem Pillay',
      title: 'SENIOR ADVISOR',
      linkedinUrl: 'https://www.linkedin.com/in/premlin-pillay-56146a1',
      email: 'premlin.pillay@crikeytech.com',
      bio: 'Prem is a proven leader in financial services and data; ex-COO, founder, and repeat VC return generator. Based across South Africa and the UK, Prem offers strategic business advice to the Executive team.'
    }
  ];

  return (
    <div className="our-people-section">
      <div className="our-people-content">
        <h2 className="our-people-title">Our people</h2>
        
        <div className="people-grid">
          {people.map((person, index) => (
            <div key={index} className="person-card">
              <div className="person-header">
                <h3 className="person-name">{person.name}</h3>
                <p className="person-title">{person.title}</p>
                {person.company && (
                  <p className="person-company">{person.company}</p>
                )}
              </div>

              <div className="person-social">
                <a 
                  href={person.linkedinUrl} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link"
                >
                  <Linkedin size={24} />
                  <span>LinkedIn</span>
                </a>
              </div>

              <a 
                href={`mailto:${person.email}`} 
                className="email-button"
              >
                <Mail size={18} />
                Email
              </a>

              {/* <div className="person-bio">
                <h4 className="bio-title">About Me</h4>
                <p className="bio-text">{person.bio}</p>
              </div> */}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurPeople;
